import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Delete } from '../../features/DeleteEntity/index.js';
import { toast } from 'react-toastify';
import { EmptyState } from '../../shared/ui/EmptyState';
import { FolderTree, Plus } from 'lucide-react';
import './Team.css';

const TeamStructurePage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    loadData();
  }, [id]);

  const loadData = () => {
    setLoading(true);
    apiRequests.team
      .getStructure(id)
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Ошибка загрузки');
        setLoading(false);
      });
  };

  const handleDelete = (groupId) => {
    apiRequests.team
      .deleteGroup(groupId)
      .then(() => {
        toast.success('Группа удалена');
        setData((prev) => ({
          ...prev,
          groups: prev.groups.filter((g) => g.id !== groupId),
        }));
      })
      .catch(() => {
        toast.error('Ошибка удаления');
      });
  };

  if (loading) {
    return <div className="team-loading">Загрузка...</div>;
  }

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <button className="team-back" onClick={() => navigate('/team-structures')}>
            ← Назад к структурам
          </button>
          <h1 className="team-title">{data?.title || 'Структура'}</h1>
          <p className="team-subtitle">{data?.groups?.length || 0} групп</p>
        </div>
        <Link to={`/team-structures/${id}/group/create`}>
          <button className="team-add-btn">+ Добавить группу</button>
        </Link>
      </div>

      <div className="team-list">
        {data?.groups?.length === 0 ? (
          <EmptyState
            icon={FolderTree}
            title="В структуре пока нет групп"
            description="Группы делят команду по направлениям — например, «Разработка» или «Дизайн». Участников добавляют уже внутри группы."
            action={{
              label: 'Добавить группу',
              to: `/team-structures/${id}/group/create`,
              icon: Plus,
            }}
          />
        ) : (
          data?.groups?.map((group) => (
            <div key={group.id} className="team-item">
              <div className="team-item-info">
                <span className="team-item-name">{group.title}</span>
                {group.members?.length > 0 && (
                  <span className="team-item-count">{group.members.length} участников</span>
                )}
              </div>
              <div className="team-item-actions">
                <Link to={`/team-structures/${id}/group/${group.id}`} className="team-btn-view">
                  Открыть
                </Link>
                <Link
                  to={`/team-structures/${id}/group/${group.id}/edit`}
                  className="team-btn-edit"
                >
                  Изменить
                </Link>
                <Delete onConfirm={() => handleDelete(group.id)} />
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TeamStructurePage;
